/* @flow */
import * as React from 'react';
import RolePicker from 'components/RolePicker';
import UserActions from 'user/UserActions';
import User from 'entities/User';
import CenteredContainer from 'components/CenteredContainer';

type Props = {
  onDone: User => void,
  onError: any => void,
};

class JoinInfoPageRolePicker extends React.Component<Props> {
  saveRole = (role: string) => {
    UserActions.update({ role }).then(this.props.onDone, this.props.onError);
  };
  render() {
    return (
      <CenteredContainer size="large" className="JoinInfoPageRolePicker">
        <RolePicker onSelect={this.saveRole} />
      </CenteredContainer>
    );
  }
}

export default JoinInfoPageRolePicker;
